import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommandesService } from 'src/app/services/commandes/commandes.service';
import { TransportorSocietyService } from 'src/app/services/transportor-society/transportor-society.service';

@Component({
  selector: 'app-new-receipt-commande',
  templateUrl: './new-receipt-commande.component.html',
  styleUrls: ['./new-receipt-commande.component.css'],
})
export class NewReceiptCommandeComponent implements OnInit {
  @Output() result = new EventEmitter<any>();

  isSaved: boolean = true;
  isClicked: Boolean = false;

  @ViewChild('autoInput') input: any;
  cmds: any = [];
  genPallets: any = [];
  pallets: any = [];
  provider: any;
  collectorList: any = [];

  data: any = {};
  selectedPallets: any[] = []; // Stocke les palettes sélectionnées

  constructor(
    private activeModal: NgbActiveModal,
    private cmdsService: CommandesService,
    private transServices: TransportorSocietyService
  ) {}

  ngOnInit(): void {
    this.listCollectors();
  }

  async listCollectors() {
    await this.transServices.allSocieties().then((res: any) => {
      if (res) {
        // console.log("leader res");
        // console.log(res);
        this.collectorList = res;
      }
    });
  }

  async onChange() {
    // console.log(this.input.nativeElement.value)
    if (this.input.nativeElement.value !== '') {
      this.genPallets = [];
      this.pallets = [];
      this.cmds = await this.cmdsService.searchCmd(
        null,
        this.input.nativeElement.value
      );
    }
  }

  onSelectionChange(event: any) {
    var cmd: any = event.option.value;
    // console.log(cmd)

    if (cmd) {
      this.genPallets = cmd?.genPallets
        .filter((pallet) => !pallet?.received)
        .map((pallet) => ({
          palletId: pallet._id,
          palletNumber: pallet.palletNumber,
          countBoxes: pallet.countBoxes,
          layersNumber: pallet.layers.length,
          name: pallet.pallet_generated.name,
        }));
      // console.log(this.genPallets)

      // console.log(cmd?.pallets)
      this.pallets = cmd?.pallets
        ?.filter((pallet) => !pallet?.received) // Filtrer les palettes non reçues
        .flatMap((pallet, index) =>
          Array.from(
            {
              length:
                pallet.quantity -
                (pallet.quantityReceived ? pallet.quantityReceived : 0),
            },
            (_, subIndex) => ({
              palletId: pallet._id,
              palletNumber: cmd?.genPallets?.length + index + subIndex + 1, // Numérotation continue
              countBoxes: pallet?.boxes?.length || 0, // Gérer le cas où "boxes" est vide
              name: pallet.name_pallet,
            })
          )
        );
      // console.log(this.pallets)
    }

    this.provider = cmd?.client_cmd;

    this.input.nativeElement.value = cmd.ref_facture_cmd;

    this.data.idCmd = cmd?._id;

    this.cmds = [];
  }

  toggleSelection(pallet: any, event: any) {
    if (event.target.checked) {
      this.selectedPallets.push(pallet);
    } else {
      this.selectedPallets = this.selectedPallets.filter(
        (p) => p.palletId !== pallet.palletId
      );
    }
    // console.log(this.selectedPallets); // Debug: Affiche les palettes sélectionnées
  }

  checkField() {
    if (
      this.data.idCmd != null &&
      this.data.idCmd != '' &&
      this.data.receptionDate != null &&
      this.data.receptionDate != '' &&
      this.data.transportor != null &&
      this.data.transportor != '' &&
      this.selectedPallets?.length > 0 &&
      this.provider != null
    )
      return true;
    else return false;
  }

  async addReceiptCmd() {
    var isValidate = this.checkField();
    if (!isValidate) {
      this.isSaved = isValidate;
      alert('Merci de remplir les champs obligatoire !!!');
    } else {
      this.data.selectedPallets = this.selectedPallets;
      // console.log(this.data)

      this.isClicked = true;

      await this.cmdsService.receiptCmd(this.data).then((res: any) => {
        // console.log("resssssssss : ")
        // console.log(res)
        this.isClicked = false;
        if (res) {
          if (res?.response) {
            this.result.emit(true);
            this.activeModal.dismiss();
          } else {
            alert(res?.msg);
          }
        } else {
          alert('erroooooooooooooooor');
        }
      });
    }
  }

  closeModal() {
    this.result.emit(null);
    this.activeModal.dismiss();
  }
}
